import React, { useEffect, useState } from 'react';
import { Form, Input, Icon, DatePicker, Radio } from 'antd';
import moment from 'moment';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const formatDateTime = (value) => {
  if (value !== 0) {
    const t = moment.unix(value);
    return t;
  }
  return;
};

const PromoForm = (props) => {
  const { form, promo } = props;
  const { getFieldDecorator } = form;
  const [state, setState] = useState({
    type: 'promotion',
  });

  const handleOnChangeType = (e) => {
    const value = e.target.value;
    setState((prev) => ({ ...prev, type: value }));
  };

  useEffect(() => {
    if (promo.end_date === 0 && promo.start_date === 0) {
      setState((prev) => ({ ...prev, type: 'news' }));
    }
  }, [promo]);

  return (
    <Form layout="vertical">
      <Item label="Title">
        {getFieldDecorator('title', {
          rules: [{ required: true, message: 'Input valid title!' }],
          initialValue: promo.title,
        })(<Input prefix={<Icon type="edit" />} placeholder="Title" />)}
      </Item>

      <Item label="Type">
        <Radio.Group onChange={handleOnChangeType} value={state.type}>
          <Radio value="promotion">Promotion</Radio>
          <Radio value="news">News</Radio>
        </Radio.Group>
      </Item>
      <Item label="Description">
        {getFieldDecorator('description', {
          rules: [{ required: true, message: 'Input valid description!' }],
          initialValue: promo.description || '',
          valuePropName: 'value',
          getValueFromEvent: (value) => value, // ReactQuill trả thẳng value
        })(<ReactQuill />)}
      </Item>

      {state.type === 'promotion' && (
        <Item label="Start - End Dates">
          {getFieldDecorator('date_range', {
            initialValue: [formatDateTime(promo.start_date), formatDateTime(promo.end_date)],
          })(<RangePicker size="default" />)}
        </Item>
      )}
    </Form>
  );
};

export default PromoForm;

// <Item label="Description">
//   {getFieldDecorator('description', {
//     rules: [{ required: true, message: 'Input valid description!' }],
//     initialValue: promo.description,
//   })(<TextArea rows={4} type="description" placeholder="Description" />)}
// </Item>



// WEBPACK FOOTER //
// ./src/components/Promo/PromoForm.js